// extracted by mini-css-extract-plugin
export default {"overviewAndMapSection":"D5uj2P","overviewPanel":"S2nEmJ"};